import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NumberOfRooms from './number-of-rooms';
import NumberOfRoomsDetail from './number-of-rooms-detail';
import NumberOfRoomsUpdate from './number-of-rooms-update';
import NumberOfRoomsDeleteDialog from './number-of-rooms-delete-dialog';

const NumberOfRoomsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NumberOfRooms />} />
    <Route path="new" element={<NumberOfRoomsUpdate />} />
    <Route path=":id">
      <Route index element={<NumberOfRoomsDetail />} />
      <Route path="edit" element={<NumberOfRoomsUpdate />} />
      <Route path="delete" element={<NumberOfRoomsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NumberOfRoomsRoutes;
